<template>
    <SeoValidation :content="content" />  
    <section class="page-hero">
      <HeroSplash
        :title="content.hero.title"
        :subtitle="content.hero.subtitle"
        theme="dark"
      />
    </section>

    <div class="main container turnkey-crcs">
      

      <section class="crc-content">
      <div class="content pt-lg">
        
        <p v-for="(paragraph, index) in content.mainContent.intro" 
           :key="index"
           :class="{ 'first-paragraph': index === 0 }">
          {{ paragraph }}
        </p>
        
        <IconList
          :items="content.mainContent.iconList"
          color="orange"
        />
      </div>
    </section>

       <section class="carousel-section">
      <!-- Noting that Client Stories handles the carousel
       and then they layout is handled here
       which I don'r really like-->
      <Carousel
        :slides="orderedSlides" 
        :initial-slide="0"
      >
        <template #slide="{ slide }">
          <ClientStory
            :logo="slide.logo"
            :client-name="slide['client-name']"
            :project-name="slide['project-name']"
            :problem="slide.problem"
            :solution="slide.solution"
            :quote="slide.quote"
          />
        </template>
      </Carousel>
    </section>

    
  </div>
  
</template>

<script setup>
import { computed } from 'vue'

import content from '@/content/turnKeyForCRCs.yml'
import { usePageHead } from '@/composables/usePageHead'
import SeoValidation from '@/components/SeoValidation.vue'

import ClientStory from '../components/ClientStory.vue'
import Carousel from '../components/Carousel.vue'
import carouselData from '@/content/client-stories.yml'
import HeroSplash from '@/components/HeroSplash.vue'
import IconList from '@/components/IconList.vue'



const orderedSlides = computed(() => {
  return carouselData.slideOrders.crc.map(slideId => ({
    ...carouselData.slides[slideId],
    id: slideId
  }))
})

// Use the page head composable
usePageHead(content)
</script>

<style lang="scss" scoped>
.turnkey-crcs {
  .page-hero {
    text-align: center;
    padding: 4rem 1rem;
    background: linear-gradient(to right, #f8f9fa, #e9ecef);
    border-radius: 8px;
    margin-bottom: 3rem;

    h1 {
      font-size: 2.5rem;
      margin-bottom: 1rem;
    }

    .lead {
      font-size: 1.25rem;
      color: #666;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  


}
</style>
